import type { JSX } from "react";
import cn from "classnames";
import { IDimension } from "@/service/review-period";
import { ComparisonMode } from "@/pages/assessment/_components";
import { getRatingColor } from "@/service/team-assessment";
import { SubdimensionItem } from "../subdimension-item";

interface DimensionItemProps {
  dimension: IDimension;
  comparisonMode: ComparisonMode;
}

export const DimensionItem = ({ dimension, comparisonMode }: DimensionItemProps): JSX.Element => {
  return (
    <div className="border-b border-gray-300 last:border-b-0">
      <div className="grid grid-cols-[1fr_216px_60px_40px] items-center gap-4 py-1">
        <div className="text-eerie-black flex items-center gap-2 text-sm font-bold">
          <span>{dimension.dimension}:</span>
          <span className={cn(getRatingColor(dimension.rating || ""))}>{dimension.rating}</span>
        </div>
      </div>
      <div>
        {dimension.subdimensions.map((subdimension, index) => (
          <SubdimensionItem key={index} subdimension={subdimension} comparisonMode={comparisonMode} />
        ))}
      </div>
    </div>
  );
};
